/** @jsx jsx */

import { jsx } from '@emotion/core';

import MultiSelectCheckboxes from './MultiSelectCheckboxes';
import { sectionStyle } from './constants';

type Props = {
  optIn: boolean;
  handleCheckBox: (key: string) => () => void;
};

function SectionOptIn({ optIn, handleCheckBox }: Props) {
  const options = [
    {
      checked: optIn,
      name: 'Receive monthly performance reports, tips and Zapier news',
      onKeyPress: handleCheckBox('optIn'),
      value: 'opt-in',
    },
  ];

  return (
    <div css={sectionStyle}>
      <MultiSelectCheckboxes
        description="We’ll send you tailored email communications based on the job functions you have selected above."
        options={options}
        title="Subscribe to Updates about this Integration"
      />
    </div>
  );
}

export default SectionOptIn;
